export { BvlNotifyComponent as BvlNotify } from './notify.component';
export { BvlNotifyModule } from './notify.module';
